import React from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import { useForm } from "react-hook-form";
import AxiosWrapper from "../../../../services/axios";
import { useEffect } from "react";
import Parser from 'react-html-parser';
import PixelsService from '../../../../services/pixels';
import AudioEyeSupport from "../../../../services/audioEyeSupport";
import AdobeScript from "../../../../services/adobeScript";
import marketing from "../../../../services/marketing";

function ReturningPayfee() {
    
  const ada = new AudioEyeSupport();
  const Setting = useStoreState((state) => state.siteSettingsModel);
  const MainPath = useStoreState((state) => state.siteSettingsModel.MainPath);
  const adobeAds = new AdobeScript();
  const resultStep = useStoreActions((actions) => actions.setDisplayResult);
  const setApplicant = useStoreActions(actions => actions.applicantModel.storeApplicantData);
  const setApplicationResult = useStoreActions((actions) => actions.applicationResultModel.setApplicationResult);
  const history = useHistory();
  const setdisplayTerms = useStoreActions((actions) => actions.setDisplayPrequalTerms);
  const axios = new AxiosWrapper();
  let [info, setInfo] = useState({
    referenceNumber: "",
    last4ssn: "",
    url: Setting.domain
  });
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    setError,
    clearErrors
  } = useForm({ mode: "onSubmit" });
  const [isLoading, setLoading] = useState(false);
  const PixelService = new PixelsService();
  const setInitPixels = useStoreActions(actions => actions.setInitPixels);
  const initPixels = useStoreState(state => state.initPixels);
  const getRoutingSettings = useStoreActions(state => state.routingSettingsModel.getRoutingSettings);
  const WaterfallEvents = { "ACTIVATION_PAYMENT": 42, "DM": 43 };
  const utms = new marketing();
  const Flow = useStoreState((state) => state.siteSettingsModel.mainSettings.Flow);
  const setMainPath = useStoreActions(
    (actions) => actions.siteSettingsModel.setMainPath
  );
  const setMainSettings = useStoreActions(
    (actions) => actions.siteSettingsModel.setMainSettings
  );

  useEffect(() => {
    if(!initPixels){
      ada.setup();
      adobeAds.setup();
      setTimeout(() =>  adobeAds.startEvent('page_view'), 5000);
      PixelService.initialize().pageView("/payfee").event("google", "tracking", "landing");
      
      setInitPixels(true);
    }
    getRoutingSettings({ Url: Setting.domain, Route: window.location.pathname});

  }, []); 

  const submit = async (data) => {
    setLoading(true); 

    try {
     const responseCall = await axios.post("/validate-payfee", info, true)
     const response = responseCall.Payload;
     const errorValidation = responseCall.Error;

     if(errorValidation) {
      setError("ssn", {
        type: "custom",
        message: errorValidation,
      });
      return;
     }

      if (response.IsPendfee) {
        setApplicationResult({ref_number: info.referenceNumber, security_deposit: response.SecurityDepositAmount});
        setApplicant({ FirstName: response.FirstName, LastName: response.LastName});
        setInfo(prev => ({ 
          ...prev,
          index: "step", 
          value: 3 
        }));
        resultStep(true);
        window.scrollTo(0, 0);
        utms.trackEvent(
          WaterfallEvents[Flow] || 0,
          Flow,
          info.referenceNumber,
          Setting.productSettings.ProductId,
          "Flow"
        );
        switch(Setting.mainSettings.Flow){
            case "DM": 
                  setdisplayTerms(true);
                  setMainSettings({ProductCode : response.ProductCode})
                  setMainPath('/terms/')
                  history.push(MainPath + "terms/payment" + window.location.search); 
                return
            default:
                 history.push(MainPath + "payment" + window.location.search); 
                 return
        }
        } else
            setError("ssn", {
            type: "custom",
            message: "We did not find your request, please review the information entered and try again.",
            });
    } catch (err) {
      
      setError("ssn", {
        type: "custom",
        message: "An error occurred. Please try again.",
      });
    } finally {
      setLoading(false); 
    }
  };

  return (
    <>
      <div
        className="row"
        id="header-text-container"
        style={{ backgroundColor: Setting.brandSettings.Primary }}
      >
      </div>
      <div className="container mt-5 mb-5">
        <form onSubmit={handleSubmit(submit)}>
          <div className="row">
            <div className="col-lg-5 col-xs-6">
              <div className="form-group">
                <label
                  className="text-center w-100"
                  htmlFor="referenceNumber"
                >
                  Enter Your Reference Number
                </label>
                <div className="input-container">
                  <input
                    value={info.referenceNumber}
                    onFocus={() => {
                      adobeAds.event("reservationNumberClick");
                    }}      
                    onInput={(e) => {
                       
                      const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 9);
                        setInfo({
                          ...info,
                          referenceNumber: value,
                        });
                      }}
                    type="text"
                    className="form-control text-center"
                    placeholder="XXXXXXXXX"
                    {...register("referenceNumber", {required : "Please enter your Reference Number", minLength : { value : 9, message : "Invalid Reference Number"}})}
                  />
                </div>
                {errors.referenceNumber ? (
                  <div className="error-message text-center">
                    {errors.referenceNumber.message}
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="form-group">
                <label className="text-center w-100" htmlFor="ssn">
                  Last 4 digits SSN
                </label>
                <div className="input-container">
                <input
                    value={info.last4ssn} 
                    onFocus={() => {
                      adobeAds.event("landing_ssn");
                    }}
                    onInput={(e) => {
                        clearErrors("notfound");
                        const regExp = /^[0-9]*$/; 
                        const value = e.target.value;

                       
                        if (regExp.test(value) && value.length <= 4) {
                        setInfo({
                            ...info,
                            last4ssn: value, 
                        });
                        }
                    }}
                    onPaste={(e) => {
                        e.preventDefault();
                        const pastedText = e.clipboardData.getData("text/plain");
                        const onlyNumbers = pastedText.replace(/[^\d]/g, ""); 
                        const trimmedValue = onlyNumbers.slice(-4); 
                        setInfo({
                        ...info,
                        last4ssn: trimmedValue,
                        });
                    }}
                    type="text"
                    maxLength={4} 
                    className="form-control text-center"
                    placeholder="Last 4 digits"
                    onKeyDown={(event) => {
                        if (event.key === "Enter") {
                        event.preventDefault();
                        const regExp = /^[0-9]{4}$/; 
                        if (regExp.test(info.last4ssn)) {
                            setValue("ssn", info.last4ssn); 
                            handleSubmit(submit)(); 
                        } else {
                            console.log("SSN must be exactly 4 digits");
                        }
                        }
                    }}
                    {...register("ssn", {
                        minLength: { value: 4, message: "Must enter exactly 4 digits" },
                        maxLength: { value: 4, message: "Must enter exactly 4 digits" },
                        required: "Please enter the last four digits of your Social Security Number",
                        pattern: {
                        value: /^[0-9]{4}$/,
                        message: "SSN must be exactly 4 digits",
                        },
                    })}
                    />
                </div>
                {errors.ssn ? (
                  <div className="error-message text-center">
                    {errors.ssn.message}
               
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="form-group">
              {errors.notfound ? (
                  <div className="error-message text-center">
                    {errors.notfound.message}
               
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="form-group">
                <button
                  onClick={() => {
                    adobeAds.startEvent('Confirm_Reservation', {reservationNumber: info.referenceNumber});
                  }}
                  disabled={isLoading}
                  style={{ backgroundColor: Setting.brandSettings.Tertiary, color: "#fff" }}
                  className="btn pt-2 pb-2 w-100 mt-3"
                  type="submit"
                >
                  {isLoading ? "SEARCHING..." : "SEARCH"}
                </button>
              </div>
            </div>
            
            <div className="col-lg-1 d-xs-none d-flex justify-content-center">
              <span className="border-left"></span>
            </div>
            <div className="col-lg-5 col-xs-6">
              <img
                src={Setting.brandSettings.CardImage}
                alt={`${Setting.brandSettings.ProductName} Card`}
                className="col-lg-12"
              />
             
                <p
                  className="col-lg-12"
                  style={{ fontSize: "small", color: "black", textAlign: "center" }}
                >
                  {Parser(Setting.brandSettings.CardImageNote || "")}
                </p>
              
              
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
export default ReturningPayfee;